import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: 'BONO 1 — Biblioteca de Prompts Maestros para ChatGPT',
    desc: '100 prompts listos para copiar, pegar y ejecutar.',
    color: 'text-green-400',
    bg: 'bg-green-500/10',
    border: 'border-green-500/20',
    linkText: 'directo a ChatGPT',
    table: [{
      area: 'Ventas',
      desc: 'Guiones, objeciones, cierres y seguimiento'
    }, {
      area: 'Redes Sociales',
      desc: 'Posts, captions, hooks y calendarios de contenido'
    }, {
      area: 'Emails',
      desc: 'Respuestas difíciles, seguimiento y propuestas'
    }, {
      area: 'Productividad',
      desc: 'Resúmenes, listas, planificación y reportes'
    }, {
      area: 'Marca Personal',
      desc: 'Bio, pitch, storytelling y posicionamiento'
    }, {
      area: 'Refinamiento',
      desc: 'Reescritura, simplificación y mejora de tono'
    }]
  }, {
    title: 'BONO 2 — Biblioteca de Lógica y Análisis para DeepSeek',
    desc: '100 prompts de análisis listos para usar con indicador de complejidad.',
    color: 'text-purple-400',
    bg: 'bg-purple-500/10',
    border: 'border-purple-500/20',
    linkText: 'directo a DeepSeek',
    table: [{
      area: 'Finanzas',
      desc: 'Ajuste de precios, márgenes y rentabilidad'
    }, {
      area: 'Datos',
      desc: 'Limpieza, análisis e interpretación'
    }, {
      area: 'Estrategia',
      desc: 'Diagnóstico de negocio y toma de decisiones'
    }, {
      area: 'Excel',
      desc: 'Fórmulas, tablas y automatización básica'
    }, {
      area: 'Auditoría',
      desc: 'Revisión de textos, contratos y propuestas'
    }, {
      area: 'Planificación',
      desc: 'Proyecciones, presupuestos y cronogramas'
    }]
  }, {
    title: 'BONO 3 — Biblioteca de Redacción y Humanización para Claude',
    desc: '100 prompts creativos listos para usar.',
    color: 'text-orange-400',
    bg: 'bg-orange-500/10',
    border: 'border-orange-500/20',
    linkText: 'directo a Claude',
    table: [{
      area: 'Storytelling',
      desc: 'Historias de marca, origen y casos de éxito'
    }, {
      area: 'Redes Sociales',
      desc: 'Contenido con voz de autor y ritmo humano'
    }, {
      area: 'Emails',
      desc: 'Mensajes cálidos, directos y sin tono corporativo'
    }, {
      area: 'Copywriting',
      desc: 'Cartas de ventas, landing pages y CTAs'
    }, {
      area: 'Contenido Largo',
      desc: 'Guiones, artículos, libros y reportes'
    }, {
      area: 'Edición',
      desc: 'Humanización, simplificación y mejora de tono'
    }]
  }];
  return <section className="py-24 bg-card border-y border-white/5" data-id="element-17">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-19">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-6" data-id="element-20">
            🎁 3 BONOS ESTRATÉGICOS — SIEMPRE INCLUIDOS
          </h2>
        </motion.div>

        <div className="space-y-12" data-id="element-21">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`rounded-2xl border ${bono.border} ${bono.bg} overflow-hidden`} data-id="element-22">
              <div className="p-6 md:p-8" data-id="element-23">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6" data-id="element-24">
                  <div data-id="element-25">
                    <h3 className={`text-2xl font-bold ${bono.color} mb-2`} data-id="element-26">
                      {bono.title}
                    </h3>
                    <p className="text-gray-300" data-id="element-27">{bono.desc}</p>
                  </div>
                  <div className="bg-white/10 px-4 py-2 rounded-lg inline-block whitespace-nowrap" data-id="element-28">
                    <span className="text-gray-400 line-through mr-2" data-id="element-29">
                      Valor: $37
                    </span>
                    <span className="text-cyan-400 font-bold" data-id="element-30">→ GRATIS</span>
                  </div>
                </div>

                <div className="overflow-x-auto" data-id="element-31">
                  <table className="w-full text-left border-collapse" data-id="element-32">
                    <thead data-id="element-33">
                      <tr className="border-b border-white/10" data-id="element-34">
                        <th className="py-3 px-4 text-white font-semibold w-1/3" data-id="element-35">
                          Área
                        </th>
                        <th className="py-3 px-4 text-white font-semibold" data-id="element-36">
                          Para qué sirve
                        </th>
                      </tr>
                    </thead>
                    <tbody data-id="element-37">
                      {bono.table.map((row, j) => <tr key={j} className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-38">
                          <td className="py-3 px-4 text-gray-300 font-medium" data-id="element-39">
                            {row.area}
                          </td>
                          <td className="py-3 px-4 text-gray-400" data-id="element-40">
                            {row.desc}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>

                <div className="mt-6 flex items-center gap-2 text-sm text-gray-400 bg-black/20 p-3 rounded-lg" data-id="element-41">
                  <ExternalLink className="w-4 h-4 text-cyan-400" data-id="element-42" />
                  <span data-id="element-43">
                    Cada prompt tiene botón linkeable {bono.linkText}.
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-44">
          <div className="inline-block bg-cyan-500/20 border border-cyan-500/30 rounded-full px-8 py-4" data-id="element-45">
            <p className="text-2xl font-bold text-white" data-id="element-46">
              Valor total bonos:{' '}
              <span className="line-through text-gray-400 mr-2" data-id="element-47">$111</span>
              <span className="text-cyan-400" data-id="element-48">
                → GRATIS con tu Mega Pack ✅
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}